import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
    marginTop: 16,
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 300,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  barContainer: {
    width: '100%',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
  },
  bar: {
    height: 24,
  },
  firstBar: {
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  lastBar: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  },
  noDataMessage: {
    width: '100%',
    marginTop: 16,
    marginBottom: 16,
    alignSelf: 'center',
    textAlign: 'center',
  },
});
